<template>
    <v-card style="border-radius: 1em;" class="pa-2">
        <v-card-title class="justify-center">
            <h1 class="text-xs-center">INFLUENCIADOR</h1>
        </v-card-title>
        <v-divider></v-divider>
        <v-alert v-show="alerta" :type="tipo" style="width: 100%;" class="pa-2" :value="true">
            <h4>{{alerta}}</h4>
        </v-alert>
        <v-divider v-show="alerta"></v-divider>
        <v-card-text>
            <v-layout fill-height wrap class="mb-3 subheading font-weight-regula">
                <v-flex xs12 class="mt-2 mb-2 primary--text">
                    <h3 class="text-xs-center">{{influenciador ? 'Detalhes do cliente'.toUpperCase() : 'Cadastrar Influenciador'.toUpperCase()}}</h3>
                </v-flex>
                <v-flex xs12>
                    {{`Nome: ${cliente.pessoa.nome} ${cliente.pessoa.sobrenome}`}}
                </v-flex>
                <v-flex xs12>
                    {{`CPF: ${cliente.pessoa.cpf}`}}
                </v-flex>
                <v-flex xs12>
                    {{`Telefone: ${cliente.pessoa.telefone}`}}
                </v-flex>
                <v-flex xs12 v-if="cliente.pessoa.data_nascimento">
                    {{`Data de Nascimento: ${formatar_data(cliente.pessoa.data_nascimento)}`}}
                </v-flex>
                <v-flex xs12>
                    {{`E-mail: ${cliente.pessoa.email}`}}
                </v-flex>
                <template v-if="influenciador">
                    <v-flex xs12 class="mt-3 mb-2 primary--text">
                        <h3 class="text-xs-center">DETALHES DO INFLUENCIADOR</h3>
                    </v-flex>
                    <v-flex xs6>
                        {{`Solicitação aceita: ${influenciador.confirmado ? 'SIM' : influenciador.confirmado === null ? 'AGUARDANDO RESPOSTA': 'NÃO'}`}}
                    </v-flex>
                    <v-flex xs6>
                        {{`Ativo: ${influenciador.ativo ? 'Sim' : 'Não'}`}}
                    </v-flex>
                    <v-flex xs6>
                        {{`Data de cadastro: ${influenciador.data_cadastro ? formatar_data(influenciador.data_cadastro) : ''} `}}
                    </v-flex>
                    <v-flex xs6>
                        {{`Frentista: ${influenciador.frentista ? 'SIM' : 'NÃO'} `}}
                    </v-flex>
                    <v-flex xs6 v-if="influenciador.frentista">
                        {{`Posto: ${influenciador.frentista.posto.nome_fantasia}`}}
                    </v-flex>
                    <v-flex xs6 v-if="influenciador.frentista">
                        {{`CNPJ: ${influenciador.frentista.posto.cnpj}`}}
                    </v-flex>
                    <v-flex xs6>
                        {{`Valor por cadastro: ${formatar(influenciador.valor_download)}`}}
                    </v-flex>
                    <v-flex xs6>
                        {{`Código: ${influenciador.codigo}`}}
                    </v-flex>
                    <v-flex xs6>
                        {{`Código usado: ${influenciador.qtd_cadastrados} ${influenciador.qtd_cadastrados === 1 ? 'vez' : 'vezes' }`}}
                    </v-flex>
                    <v-flex xs6>
                        {{`Valor ganho: ${formatar(influenciador.valor_ganho)}`}}
                    </v-flex>
                    <v-flex xs6 v-if="!influenciador.frentista">
                        {{`Rede social: ${influenciador.rede_social ? influenciador.rede_social : ''}`}}
                    </v-flex>
                    <v-flex xs6 v-if="!influenciador.frentista">
                        {{`Valor Máximo: ${influenciador.valor_maximo ? formatar(influenciador.valor_maximo) : 'Não possui'}`}}
                    </v-flex>
                    <v-flex xs12 v-if="!influenciador.frentista">
                        {{`Valor Primeira compra: ${influenciador.valor_primeira_compra ? formatar(influenciador.valor_primeira_compra) : 'R$ 0,00'}`}}
                    </v-flex>
                    <v-flex xs12 v-if="!influenciador.frentista">
                        {{`Quantidade máxima de Downloads: ${influenciador.qtd_maxima ? influenciador.qtd_maxima : 'Não possui'}`}}
                    </v-flex>
                </template>
            </v-layout>
            <v-layout wrap fill-height justify-center>
                <v-flex
                    xs12
                    style="
                        justify-content: center;
                        align-items: center;
                        display: flex;
                    "
                    >
                    <v-btn
                            round
                            v-if="!btnHide && influenciador"
                            @click="btnHide = !btnHide"
                            color="primary"
                        >
                        Alterar valor por cadastro
                    </v-btn>
                </v-flex>
                <v-card style="width: 100%;" elevation="3" v-if="btnHide || !influenciador">
                    <v-card-title class="mt-2 mb-2 primary--text subheading font-weight-regula justify-center">
                        <h3 class="mb-2">INSERIR DADOS</h3>
                    </v-card-title>
                    <v-card-text>
                        <v-layout wrap fill-height justify-center>
                            <v-flex xs6>
                                <v-text-field
                                    v-if="renderComponent"
                                    outline
                                    label="Valor ganho por cadastro"
                                    v-money="money"
                                    v-model.lazy="valor_download"
                                    class="mr-1"
                                />
                            </v-flex>
                            <v-flex xs6>
                                <v-text-field
                                    v-if="renderComponent"
                                    outline
                                    label="Valor ganho na primeira compra"
                                    v-money="money"
                                    v-model.lazy="valor_primeira_compra"
                                    class="ml-1"
                                />
                            </v-flex>
                            <v-flex xs6>
                                <v-text-field
                                    v-if="renderComponent"
                                    outline
                                    label="Valor máximo"
                                    v-money="money"
                                    v-model.lazy="valor_maximo"
                                    class="mr-1"
                                />
                            </v-flex>
                            <v-flex xs6 class="mb-3">
                                <v-text-field
                                    v-if="renderComponent"
                                    outline
                                    label="Quantidade máxima de downloads"
                                    v-model="qtd_maxima"
                                    type="number"
                                    class="ml-1"
                                />
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <v-btn
                        v-on="on"
                        round
                        @click="fechar"
                        icon
                        color="secondary"
                        class="ml-3"
                    >
                        <v-icon>close</v-icon>
                    </v-btn>
                </template>
                <span>Voltar</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-tooltip top v-if="influenciador && influenciador.ativo">
                <template v-slot:activator="{ on }">
                    <v-btn
                        v-on="on"
                        round
                        @click="desativar"
                        icon
                        color="error"
                    >
                        <v-icon>block</v-icon>
                    </v-btn>
                </template>
                <span>Desativar Influenciador</span>
            </v-tooltip>
            <v-spacer v-if="influenciador && influenciador.ativo"></v-spacer>
            <v-tooltip top v-else-if="influenciador && !influenciador.ativo">
                <template v-slot:activator="{ on }">
                    <v-btn
                        v-on="on"
                        round
                        @click="ativar"
                        icon
                        color="info"
                    >
                        <v-icon>done_outline</v-icon>
                    </v-btn>
                </template>
                <span>Ativar Influenciador</span>
            </v-tooltip>
            <v-spacer v-if="influenciador && !influenciador.ativo"></v-spacer>
            <v-tooltip top v-if="influenciador && (influenciador.confirmado === null || influenciador.confirmado == true)">
                <template v-slot:activator="{ on }">
                    <v-btn
                        v-on="on"
                        round
                        @click="responderSolicitacao(false)"
                        icon
                        color="error"
                    >
                        <v-icon>cancel</v-icon>
                    </v-btn>
                </template>
                <span>Rejeitar Influenciador</span>
            </v-tooltip>
            <v-spacer v-if="influenciador && (influenciador.confirmado === null || influenciador.confirmado == true)"></v-spacer>
            <v-tooltip top v-if="influenciador && (influenciador.confirmado === null || influenciador.confirmado == false)">
                <template v-slot:activator="{ on }">
                    <v-btn
                        v-on="on"
                        round
                        @click="responderSolicitacao(true)"
                        icon
                        color="success"
                    >
                        <v-icon>check_circle</v-icon>
                    </v-btn>
                </template>
                <span>Aceitar Influenciador</span>
            </v-tooltip>
            <v-spacer v-if="influenciador && (influenciador.confirmado === null || influenciador.confirmado == false)"></v-spacer>
            <v-tooltip top v-if="!influenciador">
                <template v-slot:activator="{ on }">
                    <v-btn
                        v-on="on"
                        round
                        @click="cadastrarInfluenciador"
                        icon
                        color="success"
                        class="mr-3"
                    >
                        <v-icon>save</v-icon>
                    </v-btn>
                </template>
                <span>Cadastrar</span>
            </v-tooltip>
            <v-tooltip top v-else>
                <template v-slot:activator="{ on }">
                    <v-btn
                        v-on="on"
                        round
                        @click="editar"
                        icon
                        color="primary"
                       :disabled="!btnHide"
                       class="mr-3"
                    >
                        <v-icon>save</v-icon>
                    </v-btn>
                </template>
                <span>Salvar</span>
            </v-tooltip>
        </v-card-actions>
    </v-card>
</template>

<script>
import { VMoney } from 'v-money'

export default {
    props: ['cliente'],
    directives: { money: VMoney },
    data: () => ({
        btnHide: false,
        renderComponent: true,
        step: 1,
        valor_download: 'R$ 0,00',
        valor_primeira_compra: 'R$ 0,00',
        valor_maximo: 'R$ 0,00',
        qtd_maxima: 0,
        influenciador: null,
        alerta: undefined,
        tipo: 'error',
        money: {
            decimal: ',',
            thousands: '.',
            prefix: 'R$ ',
            precision: 2,
            masked: false
        }
    }),
    methods: {
        fechar () {
            this.valor_download = 0
            this.step = 1
            this.$emit('fechar')
        },
        pegarInfluenciador () {
            this.renderComponent = false
            this.$store.dispatch('pegarInfluenciador', {
                id_cliente: this.cliente.id_cliente
            }).then(json => {
                this.influenciador = json
                this.valor_download = this.formatar(this.influenciador.valor_download)
                this.valor_primeira_compra = this.formatar(this.influenciador.valor_primeira_compra)
                this.valor_maximo = this.formatar(this.influenciador.valor_maximo)
                this.qtd_maxima = this.influenciador.qtd_maxima == null ? 0 : this.influenciador.qtd_maxima
            })

            this.$nextTick().then(() => {
                this.renderComponent = true
            })
        },
        cadastrarInfluenciador () {
            if (this.valor_download === 'R$ 0,00') {
                this.activeAlert('É preciso definir um valor para o campo Valor ganho por cadastro', 'error')
                return
            }
            this.renderComponent = false
            let valor = this.valor_download.split(' ')[1].split(',')
            this.valor_download = Number(`${valor[0].split('.').join('')}.${valor[1]}`)

            valor = this.valor_primeira_compra.split(' ')[1].split(',')
            this.valor_primeira_compra = Number(`${valor[0].split('.').join('')}.${valor[1]}`)

            valor = this.valor_maximo.split(' ')[1].split(',')
            this.valor_maximo = Number(`${valor[0].split('.').join('')}.${valor[1]}`)

            this.$store.dispatch('influenciador', {
                valor_download: this.valor_download,
                id_cliente: this.cliente.id_cliente,
                valor_primeira_compra: this.valor_primeira_compra <= 0 ? null : this.valor_primeira_compra,
                valor_maximo: this.valor_maximo <= 0 ? null : this.valor_maximo,
                qtd_maxima: this.qtd_maxima <= 0 ? null : this.qtd_maxima,
                method: 'POST'
            }).then(() => {
                this.renderComponent = true
                this.activeAlert('Influenciador cadastrado com sucesso.', 'success')
                this.pegarInfluenciador()
            }).catch(() => {
                this.renderComponent = true
                this.activeAlert('Não foi possível cadastrar o influenciador.', 'error')
            })
        },
        responderSolicitacao (confirmado) {
            if (confirmado && (this.valor_download === 'R$ 0,00' || !this.influenciador)) {
                this.activeAlert('É preciso definir um valor para o campo Valor ganho por cadastro', 'error')
                return
            }

            if (!this.influenciador.ativo) {
                this.activeAlert('Para realizar essa opeção ative primeiro o influenciador.', 'error')
                return
            }

            this.renderComponent = false
            let valor
            valor = this.valor_download.split(' ')[1].split(',')
            this.valor_download = Number(`${valor[0].split('.').join('')}.${valor[1]}`)

            valor = this.valor_primeira_compra.split(' ')[1].split(',')
            this.valor_primeira_compra = Number(`${valor[0].split('.').join('')}.${valor[1]}`)

            valor = this.valor_maximo.split(' ')[1].split(',')
            this.valor_maximo = Number(`${valor[0].split('.').join('')}.${valor[1]}`)

            this.$store.dispatch('influenciador', {
                valor_download: this.valor_download,
                id: this.influenciador.id,
                confirmado: confirmado,
                valor_primeira_compra: this.valor_primeira_compra <= 0 ? null : this.valor_primeira_compra,
                valor_maximo: this.valor_maximo <= 0 ? null : this.valor_maximo,
                qtd_maxima: this.qtd_maxima <= 0 ? null : this.qtd_maxima,
                method: 'PUT'
            }).then(() => {
                this.btnHide = false
                this.activeAlert(`Influenciador ${confirmado ? 'aceito' : 'rejeitado'} com sucesso.`, 'success')
                this.pegarInfluenciador()
                this.$emit('carregarNotificacoes')
                this.$emit('carregarClientes')
                this.renderComponent = true
            }).catch(() => {
                this.renderComponent = true
                this.activeAlert('Não foi possível responder solicitação.', 'error')
            })
        },
        desativar () {
            this.$store.dispatch('influenciador', {
                id: this.influenciador.id,
                method: 'DELETE'
            }).then(() => {
                this.activeAlert('Influenciador desativado com sucesso.', 'success')
                this.pegarInfluenciador()
                this.$emit('carregarClientes')
                this.renderComponent = true
            }).catch(() => {
                this.activeAlert('Não foi possível desativar influenciador.', 'error')
            })
        },
        ativar () {
            this.$store.dispatch('influenciador', {
                id: this.influenciador.id,
                method: 'PATCH'
            }).then(() => {
                this.activeAlert('Influenciador ativado com sucesso.', 'success')
                this.pegarInfluenciador()
                this.$emit('carregarClientes')
            }).catch(() => {
                this.activeAlert('Não foi possível ativar influenciador.', 'error')
            })
        },
        editar () {
            if (!this.influenciador) {
                this.activeAlert('Influenciador não encontrado.', 'error')
                return
            }

            if (!this.influenciador.ativo) {
                this.activeAlert('Para realizar essa opeção ative primeiro o influenciador.', 'error')
                return
            }

            if (this.valor_download === 'R$ 0,00') {
                this.activeAlert('É preciso definir um valor para o campo Valor ganho por cadastro.', 'error')
                return
            }

            this.renderComponent = false

            if (this.influenciador.confirmado) {
                let valor = this.valor_download.split(' ')[1].split(',')
                this.valor_download = Number(`${valor[0].split('.').join('')}.${valor[1]}`)

                valor = this.valor_primeira_compra.split(' ')[1].split(',')
                this.valor_primeira_compra = Number(`${valor[0].split('.').join('')}.${valor[1]}`)

                valor = this.valor_maximo.split(' ')[1].split(',')
                this.valor_maximo = Number(`${valor[0].split('.').join('')}.${valor[1]}`)
            }

            this.$store.dispatch('influenciador', {
                valor_download: this.valor_download,
                id: this.influenciador.id,
                valor: this.valor_download,
                confirmado: this.influenciador.confirmado,
                valor_primeira_compra: this.valor_primeira_compra <= 0 ? null : this.valor_primeira_compra,
                valor_maximo: this.valor_maximo <= 0 ? null : this.valor_maximo,
                qtd_maxima: this.qtd_maxima <= 0 ? null : this.qtd_maxima,
                method: 'PUT'
            }).then(() => {
                this.btnHide = false
                this.activeAlert('Dados editados com sucesso.', 'success')
                this.pegarInfluenciador()
                this.$emit('carregarNotificacoes')
                this.$emit('carregarClientes')
                this.renderComponent = true
            }).catch(() => {
                this.renderComponent = true
                this.activeAlert('Não foi possível editar influenciador.', 'error')
            })
        },
        formatar (valor) {
            if (valor === undefined) return 'R$ 0,00'
            if (valor === null) return 'R$ 0,00'
            if (valor === 0) return 'R$ 0,00'
            return `R$ ${valor.replace('.', ',')}`
        },
        formatar_data (data) {
            if (!data) return ''
            const ano = data.slice(0, 4)
            const mes = data.slice(5, 7)
            const dia = data.slice(8, 10)
            return `${dia}/${mes}/${ano}`
        },
        activeAlert (text, type) {
            this.alerta = text
            this.tipo = type
            const interval = setInterval(() => {
                this.alerta = undefined
                clearInterval(interval)
            }, 5000)
        }
    },
    beforeMount () {
        if (this.cliente) {
            this.pegarInfluenciador()
        }
    }
}
</script>
